import React from 'react';
import './breadcrumbs-dropdown.scss';
import { BreadcrumbsItemsInterface } from 'interfaces/breadcrumbs.interface';

const BreadcrumbsDropdownGroup: React.FC<{itemsGroup: BreadcrumbsItemsInterface[];}> = ({ itemsGroup }) => (
    <div className="breadcrumbs-dropdown__content__group">
        {
            itemsGroup.map(item => (
                <a
                    key={item.id}
                    href={item.url}
                    className={`breadcrumbs-dropdown__content__group__link 
                        ${item.showMore ? 'breadcrumbs-dropdown__content__group__link--show-more' : ''}`}
                >
                    {item.showMore && !item.name ? 'Pokaż wszystkie' : item.name}
                </a>
            ))
        }
    </div>
);

export default BreadcrumbsDropdownGroup;
